<template>
	<SearchApp v-if="showSearchApp" />
	<EmarsysToast />
	<SharedToast />
	<SharedBanner />
</template>

<script setup lang="ts">
import SearchApp from "@/SearchApp/SearchApp.vue";
import SharedToast from "@/SharedToastApp/SharedToast.vue";
import SharedBanner from "@/SharedBannerApp/SharedBanner.vue";
import EmarsysToast from "@/EmarsysToastApp/EmarsysToast.vue";

import { onMounted, ref } from "vue";

const showSearchApp = ref(false);

onMounted(() => {
	showSearchApp.value = !!(window.ocm?.config?.hasSearch && document.getElementById("header-search-container"));
});
</script>
